import React, { useEffect } from 'react';
import {Routes,  Route} from "react-router-dom";
import './styles/App.css';
import Exit from './pages/Exit.js';
import Home from "./pages/Home.js";
import Info from './pages/Info.js';
import Overview from './pages/Overview.js';
import Questions from './pages/Questions.js';
import Survey from "./pages/Survey.js";
//import { GlobalStateProvider } from './pages/GlobalStateContext.js';
import { GlobalStateProvider } from './pages/GlobalStateContext.js';



//const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function App () {
 
    return (
        <GlobalStateProvider>
            <Routes>
                <Route path="/" element={<Home />} />  
                <Route path="/survey" element={<Survey />} />
                <Route path="/questions" element={<Questions />} />
                <Route path="/info" element={<Info />} />
                <Route path="/overview" element={<Overview />} />
                <Route path="/exit" element={<Exit />}/> 
            </Routes>
        </GlobalStateProvider>
    );
}